import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {ActivatedRoute} from "@angular/router";
import { SportService } from '../services/sport.service';
@Component({
  selector: 'app-casino-detail',
  templateUrl: './casino-detail.component.html',
  styleUrls: ['./casino-detail.component.scss']
})
export class CasinoDetailComponent implements OnInit {
  url: string;
  graphicTvUrl: SafeResourceUrl;
  url_id:any;
  iframe_height:any;
  deskop:any;
  games:any;
  providerCode:any;
  gameCode:any;
  constructor(private sport: SportService,public sanitizer: DomSanitizer,public route: ActivatedRoute) { }

  ngOnInit(): void {
    let token = localStorage.getItem('userAccessToken');
   this.route.paramMap.subscribe(params => {
      this.gameCode = params.get('gameCode');
      this.providerCode = params.get('providerCode');
      this.gotoexchangeGame();
     
    });
  
  }
   isMobileDevice(userAgent) {
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  }

  gotoexchangeGame() {
    const userAgent = navigator.userAgent || navigator.vendor || window['opera'];
    let device="desktop";
    if (this.isMobileDevice(userAgent)) {
       device="mobile";
    }
    let data = {
      device:device,
      "gameData": {
        "gameCode": this.gameCode,
        "providerCode": this.providerCode
    }
    }
    this.sport.getWCOauth(data).subscribe((res) => {
      console.log(res)
      if(res.status == true){
        if(window.innerWidth > 768 ) {
          this.iframe_height=80;
          this.games = res.url;
          this.deskop=true;
        }
        else
        {
          this.iframe_height=100;
          this.deskop=false;
          this.games = res.url;
        }
        //this.url = localStorage.getItem('casino'); 
        this.graphicTvUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.games);
        // this.iUrl = res.launchUrl;
        // localStorage.setItem('casino',this.iUrl)
        // this.router.navigate(['casino-detail'])
      }
    })
  }

}
